import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../../Context/Layout.context';
import { AnnotationDefinition } from '../../../models/annotation.types';
import { changeAnnotationDefinitionActiveness } from '../../../services/admin/settings/annotations.service';
import { Prompt } from '../../Prompt/Prompt.component';

export const ChangeAnnotationDefinitionStatus: React.FC<{
  annotationDefinition: AnnotationDefinition;
  onSave: () => void;
  onCancel: () => void;
}> = (props) => {
  const { t } = useTranslation();
  const { openAlert, showLoader } = useLayoutContext();

  const getMainText = (): string => {
    return props.annotationDefinition.active
      ? "Czy na pewno chcesz dezaktywować adnotację?"
      : "Czy na pewno chcesz aktywować adnotację?"
  };

  const onConfirm = () => {
    showLoader(true);
    changeAnnotationDefinitionActiveness(props.annotationDefinition.id, !props.annotationDefinition.active)
      .then(
        (result) => (result ? openAlert('success') : openAlert('save_error')),
        (error) => openAlert('save_error'),
      )
      .catch((error) => openAlert('save_error'))
      .finally(() => {
        showLoader(false);
        props.onSave();
      });
  };

  return (
    <Prompt
      type={'confirmation'}
      open={true}
      mainText={getMainText()}
      mainActionButtonText={'TAK'}
      onCancel={props.onCancel}
      onConfirm={onConfirm}
    />
  );
};
